var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScalpFractionLGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M29 26.5H3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.252 19.251 3 19.25a.75.75 0 1 1 0-1.5h5.597a7.72 7.72 0 0 0 .655 1.501zM29 17.75a.75.75 0 1 1 0 1.5h-6.252a7.72 7.72 0 0 0 .655-1.5H29z",
    fill: "#939393",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.957 10.784 16 5l-4.957 5.784C9.955 12.028 9 13.683 9 15.5c0 3.866 3.295 7 7 7s7-3.134 7-7c0-1.817-.955-3.472-2.043-4.716zM5.5 14s-.476-1.258-.896-1.908C4.34 11.687 3 10.728 3 10.728s1.147-.536 1.47-.891C4.71 9.572 4.715 9.46 5.5 8c0 0 .723 1.5 1.03 1.837.323.355 1.47.891 1.47.891s-1.341.96-1.604 1.364C5.976 12.742 5.5 14 5.5 14zM25.5 9s-.476-1.258-.896-1.908C24.34 6.687 23 5.728 23 5.728s1.147-.536 1.47-.891c.24-.265.244-.376 1.03-1.837 0 0 .723 1.5 1.03 1.837.323.355 1.47.891 1.47.891s-1.341.96-1.604 1.364C25.976 7.742 25.5 9 25.5 9z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20c-1.676-.021-3.018-1.363-3-3",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalpFractionLGray);
export default __webpack_public_path__ + "static/media/icon_scalp_fraction_l_gray.d834b749.svg";
export { ForwardRef as ReactComponent };